import Organize from '@features/layout/components/Organize';
import { IGetServerSideProps } from 'model/global.model';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React from 'react';
import { useIntl } from 'react-intl';

const OrganizeGamyPage = ({ title }: IGetServerSideProps) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Head>
				<title>{formatMessage({ id: 'bcs-Header-Organize' })}</title>
				<link rel='icon' href='/favicon.ico' />
				<meta name='apple-mobile-web-app-capable' content='yes' />
				<meta name='apple-mobile-web-app-status-bar-style' content='black' />
				<meta
					name='viewport'
					content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
				/>
				<meta name='theme-color' content='#ffffff' />
				<meta property='og:title' content={title} key='ogTitle' />
			</Head>
			<Organize />
		</>
	);
};

export const getServerSideProps: GetServerSideProps = async () => {
	return {
		props: {
			title: 'Организирайте Gamy | Gamy.fun',
		},
	};
};

export default OrganizeGamyPage;
